import {useMutation} from "react-query";
import axios from "axios";
const updateTenant = async (config) => {
    const {data: response} = await axios.patch(`${process.env.REACT_APP_API_URL}/admin/tenants/${config.identifier}?branch=${config.branch}`, config)
    return response.data;
}

export default function useUpdateTenant(){
    return useMutation(
        'UPDATE_TENANT',
        (tenantConfig) => (updateTenant(tenantConfig))
    );
}
